import { Alert } from "antd";
import { BUSINESS_DAYS_SLA } from "../estadoOS";

export function PainelAlertas({ estado }) {
  const {
    mostrarMensagem,
    alertInfo,
    isAlertNegociacaoInicialSituacaoDiasUteis,
    isAlertNegociacaoInicial,
    isAlertSolicitacaoServicoUltrapassou,
    isAlertProcessoFinalizado,
    isAlertOrdemSuspensa,
  } = estado;

  return (
    <div className="padding10" style={{ margin: "0 30px 0 30px" }}>
      {mostrarMensagem && (
        <>
          <br />
          <Alert description={alertInfo} type="info" showIcon />
          <br />
        </>
      )}

      {isAlertNegociacaoInicialSituacaoDiasUteis && (
        <>
          <Alert
            description={`O tratamento desta Ordem de Serviço ultrapassou o SLA estipulado de [${BUSINESS_DAYS_SLA}] dias úteis`}
            type="warning"
            showIcon
          />
          <br />
          <Alert
            message="A solicitação desta Ordem de Serviço não foi efetivada pelo solicitante."
            description="Necessário entrar em contato com o solicitante da Ordem de Serviço para concluir a solicitação ou efetue o cancelamento da mesma."
            type="info"
            showIcon
          />
        </>
      )}

      {isAlertNegociacaoInicial && (
        <Alert
          message="A solicitação desta Ordem de Serviço não foi efetivada pelo solicitante."
          description="Necessário entrar em contato com o solicitante da Ordem de Serviço para concluir a solicitação ou efetue o cancelamento da mesma."
          type="info"
          showIcon
        />
      )}

      {isAlertSolicitacaoServicoUltrapassou && (
        <>
          <Alert
            message={`O tratamento desta Ordem de Serviço ultrapassou o SLA estipulado de ${BUSINESS_DAYS_SLA + 2} dias úteis.`}
            description="Aguardando a confirmação de pagamento pela rede bancária."
            type="warning"
            showIcon
          />
          <br />
          <Alert
            description="Este processo pode demorar 2 dias úteis. Necessário entrar em contato com o solicitante da Ordem de Serviço para confirmar o pagamento da mesma."
            type="info"
            showIcon
          />
        </>
      )}

      {isAlertProcessoFinalizado && <Alert description="Processo finalizado." type="success" showIcon />}

      {isAlertOrdemSuspensa && (
        <>
          <br />
          <Alert description="A execução desta Ordem de Serviço se encontra suspensa." type="warning" showIcon />
        </>
      )}
    </div>
  );
}

export default PainelAlertas;
